import * as React from 'react';

declare const rootUrl: string;

interface AttachSensorStepsProps {
    onNext: () => void;
    onBack: () => void;
}

export const AttachSensorSteps = ({ onNext, onBack }: AttachSensorStepsProps) => {
    return (
        <>
            <div className="modal-body">
                <div className="row">
                    <div className="col-md-12">
                        <h2 className="text-primary">Connect Microphone and Sensor</h2>
                    </div>
                    <div className="col-md-12">
                        <ol className="posh-list">
                            <li>Feed the air microphone wire from the VitaloJAK through the inside of the VitaloJAK pouch</li>
                            <li>Feed the chest sensor wire through the outside of the VitaloJAK pouch</li>
                            <li>Insert the sensor connector into the port on the side of the device</li>
                            <li>Secure the reinforced portion of the sensor wire using the white clip then adjust the reinforced section of the wire to allow for minimal movement of the sensor connector</li>
                        </ol>
                    </div>
                    <div className="col-md-12 text-center">
                        <img style={{ width: '100%', maxWidth: '500px' }} src={rootUrl + '/Images/Wizards/vitalojak1-3.png'} alt="" />
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" onClick={onNext}>Next</button>
                <button className="btn btn-primary btn-outline" onClick={onBack}>Back</button>
            </div>
        </>
    );
}
